export const isValidUrl = (url: string | null | undefined): boolean => {
  if (!url) return false;

  if (
    url.toLowerCase() === "n/a" ||
    url.toLowerCase() === "na" ||
    url.trim() === "-" ||
    url.trim() === ""
  ) {
    return false;
  }

  try {
    const urlObj = new URL(url);
    return urlObj.protocol === "http:" || urlObj.protocol === "https:";
  } catch (_) {
    return false;
  }
};

export const isValidSocialLink = (link: string | null | undefined): boolean => {
  return isValidUrl(link);
};
